import { useState } from 'react';

import { Box, Divider, Flex } from '@chakra-ui/react';
import { validateEmail } from '../../global/helpers/global-helpers';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';
import { splitNameInput } from '../../profile/helpers/user-helper';


export default function DsrJoinPublicDsrSetPasswordForm({
	newUserId,
	newProfileToken,
	defaultEmail,
	handleSetPasswordProfile,
	isProcessing
}) {

	const [emailInput, setEmailInput] = useState(defaultEmail);
	const [newPasswordInput, setNewPasswordInput] = useState('');
	const [confirmPasswordInput, setConfirmPasswordInput] = useState('');

	const [nameInput, setNameInput] = useState('');

	const [showPasswordError, setShowPasswordError] = useState('');
	const [showInputError, setShowInputError] = useState(false);
	const [showValidationError, setShowValidationError] = useState(false);

	//Function
	const handleSetNewPassword = () => {
		resetAllErrorStates()
		const isValidEmail = validateEmail(emailInput)

		if (!isValidEmail) {
			setShowInputError(true)
		} else {
			if (!newPasswordInput || newPasswordInput.length < 6) {
				setShowPasswordError(true)
			} else if (newPasswordInput !== confirmPasswordInput) {
				setShowValidationError(true)
			} else if (newPasswordInput && isValidEmail && newUserId) {
				const { firstName, lastName } = splitNameInput(nameInput)
				const firstNameInput = firstName || "";
				const lastNameInput = lastName || "";
				handleSetPasswordProfile(newPasswordInput, newProfileToken, firstNameInput, lastNameInput)
			}
		}
	}


	const resetAllErrorStates = () => {
		setShowInputError(false)
		setShowPasswordError(false)
		setShowValidationError(false)
	}

	const onChangeHandler = (event) => {
		switch (event.target.name) {
			case ('email'): {
				showInputError && setShowInputError(false)
				setEmailInput(event.target.value.trim())
				break;
			}
			case ('password-input'): {
				showPasswordError && setShowPasswordError(false)
				setNewPasswordInput(event.target.value.trim())
				break;
			}
			case ('repeat-password'): {
				showValidationError && setShowValidationError(false)
				setConfirmPasswordInput(event.target.value.trim())
				break;
			}
			case ('user-name-input'): {
				setNameInput(event.target.value)
				break;
			}
			default: {
				break;
			}
		}
	};


	return (
		<>

			<Box w="100%" maxW='25em' align="center" px='1em'>
				<Box textAlign='center' fontSize='1.5em' color='brandDark.500' mb='0.5em'>Introduce Yourself</Box>
				<Box textAlign='center' fontSize='0.875em' color='gray.500' fontWeight='400' lineHeight='1.375em' mb='2em'>Help others know how to address you</Box>

				<Flex direction='column' gap='0.5em' >

					<LaunchdeckFormInput
						label='Your name'
						name={'user-name-input'}
						onChange={onChangeHandler}
						value={nameInput || ""}
						isDisabled={isProcessing}
					/>

					<LaunchdeckFormInput
						label='Create a password'
						name={'password-input'}
						onChange={onChangeHandler}
						value={newPasswordInput || ""}
						type="password"
						isDisabled={isProcessing}
						isRequired={true}
						errorLogic={showPasswordError}
						errorMessage="Please set a secure password that contains more than 6 characters"
					/>

					<LaunchdeckFormInput
						label='Confirm password'
						name={'repeat-password'}
						onChange={onChangeHandler}
						value={confirmPasswordInput || ""}
						isRequired={true}
						type="password"
						isDisabled={isProcessing}
						errorLogic={showValidationError}
						errorMessage="Your confirmation password did not match."
					/>

					<Box mt='1em'>
						<Divider mb='0.5em' />
						<LaunchdeckFormInput
							label='Email'
							name={'email'}
							onChange={onChangeHandler}
							value={emailInput || ""}
							isDisabled={validateEmail(emailInput)}
							errorLogic={showInputError}
							errorMessage="Please provide a valid email"
						/>
					</Box>
				</Flex>

				<Flex w='100%' my='2em'>
					<Flex justify='flex-end' w='100%'>
						<LaunchdeckButton bg='brand.500' color='gray.50' w='100%' label='Confirm' loadingLogic={isProcessing} onClick={() => handleSetNewPassword()} />
					</Flex>
				</Flex>
			</Box>
		</>
	);
};


